import * as React from 'react';

// COMPONENTS
import MainMenu from '../MainMenu';
import OrganisationMenu from '../OrganisationMenu';
import AccountMenu from '../AccountMenu';
import PageName from '../PageName';

interface propsType {
	title?: string;
	text?: string;
	showBack?: boolean;
	showLogo?: boolean;
	children: React.ReactNode;
	className?: string;
}

const LayoutTwoColumn: React.FunctionComponent<propsType> = ({
	title,
	text,
	showBack,
	showLogo,
	children,
	className = ''
}) => {
	// Controls Burger Menu show or hide
	const [isBurgerMenuShow, setIsBurgerMenuShow] = React.useState(false);

	return (
		<main className={'layout-two-column ' + className}>
			<div className="sidebar">
				<OrganisationMenu isBurgerMenuShow={isBurgerMenuShow} setIsBurgerMenuShow={setIsBurgerMenuShow} />

				<MainMenu isBurgerMenuShow={isBurgerMenuShow} setIsBurgerMenuShow={setIsBurgerMenuShow} />
			</div>

			<div className="page">
				<AccountMenu />

				<PageName title={title} text={text} showBack={showBack} showLogo={showLogo} />
				
				<div className="page-content">{children}</div>
			</div>
		</main>
	);
};

export default LayoutTwoColumn;
